
      
  <mat-toolbar>
    <span>Water Tank</span>
    <span class="fill-remaining-space"></span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
  </mat-toolbar>


<form [formGroup]="form"  autocomplete="off"  (ngSubmit)="saveButtonClick()" class="normal-form">
  <mat-grid-list cols="1" rowHeight="200px">
    <mat-grid-tile>
      <div class="row">
        <input readonly type="hidden" formControlName="id"> 
      </div>    
      <div class="controles-container">

        <mat-form-field>
            <input  formControlName="date" matInput [readonly]="isReadOnly" [matDatepicker]="picker" placeholder="Date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error>This field is required</mat-error>
          </mat-form-field> 

        <mat-form-field>
          <input formControlName="liters" [readonly]="isReadOnly" matInput placeholder="Liters">
          <mat-error>This field is required</mat-error>
        </mat-form-field>


        <div class="button-row">          
            <button *ngIf="hideBtn" class="float-right" mat-raised-button color="primary" type="submit">
              <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Save
            </button>    
            <button type="button" class="float-right" mat-button (click)="onClose()">Cancel</button>       
          </div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</form>

<!-- Form Values : {{ userForm.value | json }}  -->